export enum AR_MODULE {
  QUALIFICATION_CHECK = 'Qualification Check',
  VISA_APPLICATION = 'Visa Application',
  REGISTRATION_CARD = 'Registration and ID Card',
}

export enum QUALIFICATION_MODULE {
  APPLICANT_PARTICULARS = 'Applicant Particulars',
  QUALIFICATION_CHECK = 'Qualification Check',
  VISA_APPLICATION = 'Visa Application',
}

export enum QUALIFICATION_CHECK_STATUS {
  CREATED = 'CREATED',
  CHECKING = 'CHECKING',
  PASSED = 'PASSED',
  MODIFICATION_REQUIRED = 'MODIFICATION_REQUIRED',
  WAIVED = 'WAIVED',
  FAILED = 'FAILED',
}

export enum VISA_STATUS {
  PENDING_APPLICATION_SUBMISSION = 'PENDING_APPLICATION_SUBMISSION',
  APPLICATION_RECEIVED = 'APPLICATION_RECEIVED',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACTIVATED = 'ACTIVATED',
}

export const QUALIFICATION_CHECK_STATUS_TEXT = {
  CREATED: 'Created',
  CHECKING: 'Checking',
  PASSED: 'Passed',
  MODIFICATION_REQUIRED: 'Modification Required',
  WAIVED: 'Waived',
  FAILED: 'Failed',
};
